import React from "react";
import PropTypes from 'prop-types';

import "./Loader.scss";

export const Loader = ({title}) => (
  <div className="loader">
    <div className="loader__spinner"></div>
    <div className="loader__image"></div>    
    {title && (<p>{title}</p>)}    
  </div>
);

Loader.propTypes = {
  title: PropTypes.string,
};